/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CriesPainScaleAliases {
  CRIES_FACIAL_EXPRESSION_FIELD = 'cries-facial-expression-field',
  CRIES_FACIAL_EXPRESSION_FORM = 'cries-facial-expression-form',
  CRIES_FACIAL_EXPRESSION_RADIO_GROUP = 'cries-facial-expression-radio-group',
  CRIES_FACIAL_EXPRESSION_TEXT = 'cries-facial-expression-text',
  CRIES_PAIN_SCALE_CONTEXTUAL_BAR = 'cries-pain-scale-contextualBar',
  CRIES_PAIN_SCALE_LAYOUT = 'cries-pain-scale-layout',
  CRIES_PAIN_SCALE_PANEL = 'cries-pain-scale-panel',
  CRIES_REFERENCE_MODAL = 'cries-reference-modal',
  CRYING_FIELD = 'crying-field',
  CRYING_FORM = 'crying-form',
  CRYING_RADIO_GROUP = 'crying-radio-group',
  FACIAL_EXPRESSION_TEXT = 'facial-expression-text',
  INCREASED_HR_AND_BP_FIELD = 'increased-hr-and-bp-field',
  INCREASED_HR_AND_BP_FORM = 'increased-hr-and-bp-form',
  INCREASED_HR_AND_BP_RADIO_GROUP = 'increased-hr-and-bp-radio-group',
  INCREASED_HR_AND_BP_TEXT = 'increased-hr-and-bp-text',
  KIND_SLEEP_LAST_HOUR_FIELD = 'kind-sleep-last-hour-field',
  KIND_SLEEP_LAST_HOUR_FORM = 'kind-sleep-last-hour-form',
  KIND_SLEEP_LAST_HOUR_RADIO_GROUP = 'kind-sleep-last-hour-radio-group',
  KIND_SLEEP_LAST_HOUR_TEXT = 'kind-sleep-last-hour-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  OXYGEM_DEMAND_FORM = 'oxygem-demand-form',
  OXYGEN_DEMAND_FIELD = 'oxygen-demand-field',
  OXYGEN_DEMAND_RADIO_GROUP = 'oxygen-demand-radio-group',
  OXYGEN_DEMAND_TEXT = 'oxygen-demand-text',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_PANEL = 'reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
}
export { CriesPainScaleAliases };
